/* FA Scroll Reveal -- fa-scroll-reveal.js */
(function () {
  var REVEAL = 'fade-in-enabled';
  var STAGGER = 'fade-in-stagger';
  var VISIBLE = 'animated';

  /* Image containers + carousels — text and buttons are visible immediately */
  var SINGLE_SELECTORS = [
    '.fa-hero-banner__media',
    '.fa-welcome-intro__image',
    '.fa-welcome-intro-m__image',
    '.fa-au__media',
    '.fa-ba__slider',
    '.fa-reviews__slider',
    '.fa-find-salon__map',
    '.fa-skn__card-img',
    '.fa-sig__card-bg',
  ];

  var STAGGER_SELECTORS = [];

  function tag(el, cls) {
    if (!el.classList.contains(REVEAL) && !el.classList.contains(STAGGER)) {
      el.classList.add(cls);
    }
  }

  /* Double rAF: ensures browser paints opacity:0 before transition starts.
     Eliminates the visible flash for above-fold elements on page load. */
  function reveal(el) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add(VISIBLE);
      });
    });
  }

  function setup() {
    SINGLE_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { tag(el, REVEAL); });
    });
    STAGGER_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { tag(el, STAGGER); });
    });

    var targets = document.querySelectorAll('.' + REVEAL + ', .' + STAGGER);
    if (!targets.length) return;

    /* rootMargin -120px bottom: elements must be 120px above viewport bottom
       before triggering -- creates clear one-by-one reveal when scrolling slowly */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px -120px 0px'
    });

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
